/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { getStorage } from 'src/core/utils/getStorage';
import { LuisConstants } from 'src/core/utils/LuisConstants';

/**
 * Set the user session id.
 *
 * @param newSessionID a unique id to identify the user current session.
 */
export const setUserSessionId = (newSessionID: string) => {
    getStorage('sessionStorage').setData(`${LuisConstants.Telemetry.LuisUserSessionId}`, newSessionID);
};

/**
 * Get the current user session id.
 *
 */
export const getUserSessionId = (): string => getStorage('sessionStorage').getData(`${LuisConstants.Telemetry.LuisUserSessionId}`);
